import { t } from '@avalara/bat-apps-shared/i18n';

import type { PartnerSignupInfo } from '@avalara/types/reducer-states';

import ExternalLink from '../external-link';
type Props = {
  partnerSignup?: PartnerSignupInfo;
};

const ThirdBulletContent = ({ partnerSignup }: Props) => {
  const isProductName = partnerSignup?.name || null;
  switch (isProductName) {
    case 'QuickBooks Desktop':
    case 'QuickBooks Online':
      return (
        <span>
          {'Annual plans start at $52.50 '}
          <ExternalLink
            href='https://www.avalara.com/simplify/en/quickbooks-desktop-free-trial.html#pricing'
            alwaysOpenInNewTab
          >
            {t('client.general.learn-more-1')}
          </ExternalLink>
        </span>
      );
    default:
      return (
        <ExternalLink href='https://youtu.be/RjAY9xsWidI' alwaysOpenInNewTab>
          {t('client.general.learn-what-avalara-can-do-for-you')}
        </ExternalLink>
      );
  }
};

export default ThirdBulletContent;
